import { z } from "@/zod";

export const QUANTITY_SINGLE = "single";
export const QUANTITY_MANY = "many";

export const QUANTITY = [QUANTITY_SINGLE, QUANTITY_MANY] as const;

export default z.enum(QUANTITY);
